import * as React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

import Localization from '../../config/localization';

import ElectricEnergySvg from '../../components/Svg/electricEnergy';
import NaturalGasSvg from '../../components/Svg/naturalGas';
import PersonsSvg from '../../components/Svg/persons';
import ReportsSvg from '../../components/Svg/reports';

import './Dashboard.scss';
import { generatePath } from 'react-router';
import { AidType, Routes } from '../../constants/routes';

class Dashboard extends React.Component<Dashboard.IProps, Dashboard.IState> {
  state = {
    collapseAdditions: false,
    collapseAids: false
  };


  renderElementCollapse = (props: {
    title: string,
    to: string,
    className?: string
  }) => {
    const { title, to, className = 'w-50 mr-3' } = props;

    return <Link
      to={to}
      className={`${className} bg-eon-ultra-light-grey c-pointer`}
    >
      <PersonsSvg className="m-5" />
      <h4 className="eon-title eon-darkgrey m-4">{title}</h4>
    </Link>;
  };

  render() {
    return (
      <Container className="dashboard p-0 my-5">
        <div className="w-100 d-inline-flex flex-nowrap mb-5 aid-type-container">
          <Link to={generatePath(Routes.AidsSearch, { aidType: AidType.NaturalGas })} className="w-50 mr-4 bg-eon-red">
            <NaturalGasSvg className="m-5" />
            <h4 className="eon-title eon-white ml-5 mb-5">{Localization.dashboardNaturalGas}</h4>
          </Link>
          <Link to={generatePath(Routes.AidsSearch, { aidType: AidType.ElectricEnergy })}
                className="w-50 ml-4 bg-eon-red">
            <ElectricEnergySvg className="m-5" />
            <h4 className="eon-title eon-white ml-5 mb-5">{Localization.dashboardElectricEnergy}</h4>
          </Link>
        </div>
        <div className="w-100 d-inline-flex flex-nowrap mb-5 aid-type-container">
          <Link to={generatePath(Routes.AdditionSearch, { aidType: AidType.NaturalGas })}
                className="w-50 mr-4 bg-eon-red">
            <NaturalGasSvg className="m-5" />
            <h4 className="eon-title eon-white ml-5 mb-5">{Localization.dashboardAdditionNaturalGas}</h4>
          </Link>
          <Link to={generatePath(Routes.AdditionSearch, { aidType: AidType.ElectricEnergy })}
                className="w-50 ml-4 bg-eon-red">
            <ElectricEnergySvg className="m-5" />
            <h4 className="eon-title eon-white ml-5 mb-5">{Localization.dashboardAdditionElectricEnergy}</h4>
          </Link>
        </div>
        <div className="w-100 d-inline-flex flex-nowrap mt-4 action-container">
          {this.renderElementCollapse({
            title: Localization.dashboardImportBeneficiary,
            to: Routes.FileImport,
            className: 'w-32 mr-3'
          })}
          {this.renderElementCollapse({
            title: Localization.dashboardImportAddition,
            to: Routes.FileImportAdditions,
            className: 'w-32 mx-auto'
          })}
          <Link to={Routes.Report} className="w-32 ml-3 bg-eon-ultra-light-grey">
            <ReportsSvg className="m-5" />
            <h4 className="eon-title eon-darkgrey m-4">{Localization.dashboardReport}</h4>
          </Link>
        </div>
        <div className="w-100 d-inline-flex flex-nowrap mt-4 action-container">
          {this.renderElementCollapse({
            title: Localization.dashboardImportBeneficiaryAJPIS,
            to: Routes.FileImportAJPIS,
            className: 'w-50 mr-3'
          })}
          {this.renderElementCollapse({
            title: Localization.dashboardImportAdditionAJPIS,
            to: Routes.FileImportAdditionsAJPIS,
            className: 'w-50 ml-3'
          })}
        </div>
      </Container>
    );
  }
}

export default Dashboard;
